<template>
  <div class="rank-content">
    <div class="content-header">
      <img class="section-top" src="@/assets/imgs/act/wc2026/section-top.png" alt="section-title-icon">
      <img class="section-title" :src="rankTitle" alt="section-title">
    </div>



    <!-- 我的排名卡片 -->
    <!-- <div class="my-rank-card" v-if="state.data.myRank > 0 || state.data.myWinCount > 0">
      <div class="my-info-item">
        <div class="my-label">{{ $t('wc2026.rank.myRank') }}</div>
        <div class="my-value">
          {{ state.data.myRank > 0 ? '#' + state.data.myRank : $t('wc2026.rank.notInList') }}
        </div>
      </div>
      <div class="my-info-item">
        <div class="my-label">{{ $t('wc2026.rank.myWinCount') }}</div>
        <div class="my-value win">{{ state.data.myWinCount }}</div>
      </div>

    </div> -->

    <!-- 排行榜 -->
    <div class="rank-table" v-if="state.data.rankList && state.data.rankList.length > 0">
      <div class="rank-thead">
        <div class="th rank-col">{{ $t('wc2026.rank.rank') }}</div>
        <!-- <div class="th player-col">{{ $t('wc2026.rank.nickname') }}</div> -->
        <div class="th player-col">{{ $t('wc2026.rank.winCount') }}</div>
        <div class="th count-col">{{ $t('wc2026.accountId') }}</div>
      </div>
      <div class="rank-tbody">
        <div
          class="rank-row"
          v-for="item in state.data.rankList"
          :key="item.rank"
          :class="{ 'my-row': item.accountId === myAccountId }"
        >
          <div class="td rank-col flex-center">
            <div class="rank-badge flex-center" :class="getRankClass(item.rank)">{{ item.rank }}</div>
          </div>
          <div class="td nickname-col flex-center">
            <div class="nickname">{{ item.winCount }}</div>
          </div>
          <div class="td account-id-col flex-center">
            <span class="account-id">{{ item.accountId }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="empty-tip" v-else-if="!state.loading">
      {{ $t('wc2026.noData') }}
    </div>
    
    <div class="rank-award-wrap">
      <div class="rank-title-icon"></div>
      <div class="rank-title-text">{{ $t('wc2026.rank.awardDes') }}</div>
      <div class="rank-sub-des">{{ $t('wc2026.rank.des1') }}</div>
        <!-- 称号奖励说明 -->
        <div class="title-awards-list">
          <div class="title-award-item" v-for="(award, index) in awards" :key="index">
            <div class="award-icon-wrap flex-center">
              <img class="award-icon" :src="award.icon" alt="award-icon">
            </div>
            <div class="tier-title">{{ award.name }}</div>
            
          </div>
        </div>
        <div class="rank-sub-des">{{ $t('wc2026.rank.des2') }}</div>
        <div v-if="false" :class="`canReceiveReward-btn flex-center ${getRewardStatusClass()}`" @click="handleReceiveReward">
          {{ getRewardStatusText() }}
        </div>
      </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { reactive, computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { getItemIcon } from '@/views/act/wc2026/item'
import WcApi from '@/config/wcActApi'
import rankTitleEn from '@/assets/imgs/act/wc2026/rank/titleen.png'
import rankTitleZh from '@/assets/imgs/act/wc2026/rank/titlezh.png'
import rankTitleVi from '@/assets/imgs/act/wc2026/rank/titlevi.png'
import rankTitleTh from '@/assets/imgs/act/wc2026/rank/titleth.png'
import rankTitleId from '@/assets/imgs/act/wc2026/rank/titleid.png'

const { t } = useI18n()
const store = useStore()

const locale = useI18n().locale
const rankTitle = computed(() => {
  switch (locale.value) {
    case 'tw':
      return rankTitleZh
    case 'en':
      return rankTitleEn
    case 'vi':
      return rankTitleVi
    case 'th':
      return rankTitleTh
    case 'id':
      return rankTitleId
    case 'hk':
      return rankTitleZh
    default:
      return rankTitleEn
  }
})



const myAccountId = computed(() => store.state.cpUserInfo?.cpUserId || '')

const state = reactive({
  loading: false,
  data: {
    rankList: [],
    myRank: 0,
    rewardStatus: 0,
  },
})

const awards = [{
  name: t('wc2026.item.id_90301906'),
  icon: getItemIcon('90301906', locale.value),
}, {
  name: t('wc2026.item.id_90501208'),
  icon: getItemIcon('90501208', locale.value),
}, {
  name: t('wc2026.item.id_70100101'),
  icon: getItemIcon('70100101', locale.value),
}]
const getRankClass = (rank) => {
  if (rank === 1) return 'gold'
  if (rank === 2 || rank === 3) return 'blue'
  return ''
}

const getRewardStatusClass = () => {
  if (state.data.rewardStatus === 1) return 'active'
}

const getRewardStatusText = () => {
  if (state.data.rewardStatus === 2) return t('wc2026.received')

  if (state.data.rewardStatus === 1) return t('wc2026.canReceive')
  return t('wc2026.notReach')
}

const loadData = async () => {
  state.loading = true
  try {
    const res = await WcApi.getRankList({})
    state.data = res
  } catch (e) {
    console.error(e)
  } finally {
    state.loading = false
  }
}

const handleReceiveReward = async () => {
    if (state.data.rewardStatus !== 1) {
      return
    }
    try {
      await WcApi.receiveRankReward({})
      state.data.rewardStatus = 2
      toastService.show(t('wc2026.rank.receiveRewardSuccess'))
    } catch (e) {
      console.error(e)
    }
}

watch(() => store.state.actUserInfo, (newVal) => {
  if (newVal && newVal.token) {
    loadData();
  }
}, {
  immediate: true,
  deep: true,
});
</script>

<style lang="less" scoped>

.rank-content {
  .content-header {
    margin-bottom: 24px;


  }
}

.title-awards {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;

  .title-award-item {
    flex: 1;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    padding: 16px 18px;
    text-align: center;

    .tier-range {
      font-size: 18px;
      color: rgba(255,255,255,0.4);
      margin-bottom: 6px;
    }

    .tier-title {
      font-size: 22px;
      font-weight: bold;
      color: #ffc107;
      margin-bottom: 6px;
    }

    .tier-rewards {
      font-size: 18px;
      color: rgba(255,255,255,0.5);
      line-height: 1.5;
    }
  }
}

.my-rank-card {
  display: flex;
  align-items: center;
  gap: 0;
  background: rgba(76, 175, 80, 0.06);
  border: 1px solid rgba(76, 175, 80, 0.25);
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 24px;

  .my-info-item {
    flex: 1;
    text-align: center;

    .my-label {
      font-size: 20px;
      color: rgba(255,255,255,0.4);
      margin-bottom: 4px;
    }

    .my-value {
      font-size: 40px;
      font-weight: bold;
      color: #e0e6f0;

      &.win { color: #4caf50; }
    }
  }

  .reward-status-chip {
    margin-left: auto;

    .status-tag {
      font-size: 20px;
      padding: 8px 20px;
      border-radius: 20px;

      &.pending { background: rgba(255,255,255,0.08); color: rgba(255,255,255,0.4); }
      &.sent { background: rgba(76, 175, 80, 0.15); color: #4caf50; border: 1px solid rgba(76, 175, 80, 0.35); }
      &.not-in { background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.25); }
    }
  }
}

.rank-table {
  background-image: url('~@/assets/imgs/act/wc2026/bg-blue.png');
  background-size: auto;
  background-repeat: repeat;
  background-position: center;
  overflow: auto;
  height: 450px;
  overflow-y: auto;

  .rank-thead {
    display: flex;
    align-items: center;
    height: 48px;
    .th {
      font-weight: bold;
      flex: 1;
      text-align: center;
    }
  }

  .rank-tbody {
    .rank-row {
      display: flex;
      height: 70px;
      margin-bottom: 10px;

      &.my-row {
        background: rgba(76, 175, 80, 0.08);
      }
      .td {
        flex: 1;
        text-align: center;
        justify-content: center;
        font-size: 30px;
        font-weight: bold;
      }
    }

    .rank-badge {
      font-size: 24px;
      font-weight: bold;
      height: 40px;
      width: 40px;
      font-size: 20px;
      background-image: url('~@/assets/imgs/act/wc2026/rank/gray.png');
      &.gold {
        height: 70px;
        width: 70px;
        font-size: 30px;
        background-size: contain;
        background-image: url('~@/assets/imgs/act/wc2026/rank/gold.png');
      }
      &.blue {
        height: 59px;
        width: 59px;
        font-size: 26px;
        background-image: url('~@/assets/imgs/act/wc2026/rank/blue.png');
      }
      }
    }
  }









.section-title {
  height: 47px;
  width: auto;
  margin: 0 auto;
  display: block;
}
.section-top {
  width: 100%;
  height: 43px;
}
.empty-tip {
  text-align: center;
  padding: 60px 0;
  font-size: 24px;
}
.rank-award-wrap {
  .rank-title-icon {
    width: 211px;
    height: 9px;
    margin: 20px auto;
    background-image: url('~@/assets/imgs/act/wc2026/rank/rankTitleIcon.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .rank-title-text {
    font-size: 17px;
    color: #1B0926;
    text-align: center;
    margin-bottom: 21px;
  }
  .title-awards-list {
    display: flex;
    justify-content: center;
    .title-award-item {
      margin-right: 59px;
      .award-icon-wrap {
        width: 153px;
        height: 153px;
        background-image: url('~@/assets/imgs/act/wc2026/rank/awardBg.png');
        background-size: cover;
        .award-icon {
          width: 140px;
          height: auto;
          object-fit: cover;
        }
      }
      .tier-title {
        text-align: center;
        margin-top: 17px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .canReceiveReward-btn {
    width: 167px;
    height: 55px;
    background-image: url('~@/assets/imgs/act/wc2026/rank/btn-gray.png');
    background-size: cover;
    margin:20px auto;
    color: #fff;

  }
  .rank-sub-des {
    font-size: 17px;
    color: #1B0926;
    text-align: center;
    padding: 20px;
  }
}

</style>
